import Marquee from "react-fast-marquee";
import { partnerLogos } from "@/data/siteContent";
import { Reveal } from "@/components/common/Reveal";
import { Button } from "@/components/ui/button";

export default function PartnershipsPage() {
  const allPartnersForStrip = partnerLogos;

  return (
    <div className="mx-auto w-full max-w-7xl space-y-10 pb-16 sm:space-y-14" data-testid="partnerships-page">
      <Reveal>
        <section className="space-y-5" data-testid="partnerships-header-section">
          <p className="font-oswald text-xs uppercase tracking-[0.24em] text-accent" data-testid="partnerships-kicker">
            Brand Partnerships
          </p>
          <h1 className="font-oswald text-4xl uppercase text-white sm:text-5xl" data-testid="partnerships-main-heading">
            Connecting Brands With India's Active Audiences
          </h1>
          <p className="max-w-3xl text-sm text-blue-100/88 sm:text-base" data-testid="partnerships-intro-text">
            We build athlete-led and community-led collaborations across sports, wellness, and esports—with campaign
            strategy, execution, and optimization under one roof.
          </p>
        </section>
      </Reveal>

      <Reveal delay={0.1}>
        <section className="rounded-2xl border border-blue-100/20 bg-card/70 py-6" data-testid="partnerships-logo-marquee-section">
          <Marquee gradient={false} speed={36} pauseOnHover={false} pauseOnClick={false} direction="right">
            <div className="flex items-center gap-5 px-3" data-testid="partnerships-logo-marquee-track">
              {allPartnersForStrip.map((brand, idx) => (
                <a
                  href={brand.website}
                  target="_blank"
                  rel="noreferrer"
                  className="flex h-20 w-44 items-center justify-center rounded-xl border border-blue-100/20 bg-[#02133f]/85 px-4 transition-colors duration-300 hover:border-accent/70"
                  key={`${brand.name}-${idx}`}
                  data-testid={`partner-logo-link-${idx + 1}`}
                >
                  {brand.logoUrl ? (
                    <img
                      src={brand.logoUrl}
                      alt={`${brand.name} logo`}
                      className="max-h-12 w-full object-contain grayscale opacity-95"
                      data-testid={`partner-logo-image-${idx + 1}`}
                    />
                  ) : (
                    <span
                      className="font-oswald text-xs uppercase tracking-[0.14em] text-blue-100/85"
                      data-testid={`partner-logo-placeholder-${idx + 1}`}
                    >
                      {brand.name}
                    </span>
                  )}
                </a>
              ))}
            </div>
          </Marquee>
        </section>
      </Reveal>

      <section className="grid gap-5 md:grid-cols-3" data-testid="partnerships-process-grid">
        {["Discover", "Structure", "Scale"].map((step, idx) => (
          <Reveal key={step} delay={idx * 0.08}>
            <article className="h-full rounded-2xl border border-blue-100/20 bg-[#041748]/72 p-6" data-testid={`partnership-step-${idx + 1}`}>
              <p className="font-oswald text-xs uppercase tracking-[0.24em] text-primary" data-testid={`partnership-step-label-${idx + 1}`}>
                Step {idx + 1}
              </p>
              <h2 className="mt-3 font-oswald text-2xl uppercase text-white" data-testid={`partnership-step-title-${idx + 1}`}>
                {step}
              </h2>
              <p className="mt-3 text-sm text-blue-100/88" data-testid={`partnership-step-text-${idx + 1}`}>
                {step === "Discover" && "We identify shared values between athlete identity and brand objectives."}
                {step === "Structure" && "We design campaign structure, talent stack, and platform rollout timelines."}
                {step === "Scale" && "We execute, report, and optimise for sustained impact and conversion."}
              </p>
            </article>
          </Reveal>
        ))}
      </section>

      <Reveal delay={0.12}>
        <section className="rounded-2xl border border-blue-100/20 bg-card/70 p-8" data-testid="cross-brand-collaboration-section">
          <p className="font-oswald text-xs uppercase tracking-[0.24em] text-accent" data-testid="cross-brand-kicker">
            Cross-Brand Collaboration
          </p>
          <p className="mt-4 text-sm text-blue-100/88 sm:text-base" data-testid="cross-brand-description">
            We help complementary brands co-create with shared audiences—unlocking stronger storytelling and more
            cost-efficient reach across sports and wellness communities.
          </p>
        </section>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="rounded-2xl border border-blue-100/20 bg-card/70 p-8" data-testid="partnerships-contact-cta">
          <h3 className="font-oswald text-2xl uppercase text-white" data-testid="partnerships-cta-heading">
            Ready To Build Your Next Sports Partnership?
          </h3>
          <Button asChild className="mt-6 rounded-full bg-primary px-6 font-oswald uppercase tracking-[0.16em] text-white hover:bg-accent hover:text-[#031447]">
            <a href="mailto:inquiries@purnamtalent.com" data-testid="partnerships-contact-button">Contact Us</a>
          </Button>
        </div>
      </Reveal>
    </div>
  );
}